export default __webpack_public_path__ + "static/media/icon_down_simple_black.fd416bdb.svg";